const FONT_LOAD_TIMEOUT_MS = 15000
const FONT_LOAD_ERROR = 'Não foi possível carregar a fonte Noto Sans. Recarregue a página e tente novamente antes de importar ou exportar.'

// fonts.ready alone does not request an unused webfont. Load each required
// face before measuring, so a cold cache cannot silently use Arial metrics.
export async function loadTemplateFonts(elements, fontSet = globalThis.document?.fonts) {
  const faces = new Set(
    elements
      .filter((element) => element.type === 'text' && element.fontFamily === 'Noto Sans')
      .map((element) => `${element.italic ? 'italic' : 'normal'} ${element.bold ? 700 : 400} 12px "Noto Sans"`),
  )
  if (!faces.size) return
  if (!fontSet?.load) throw new Error(FONT_LOAD_ERROR)
  let timeout
  try {
    await Promise.race([
      Promise.all([...faces].map(async (face) => {
        const loaded = await fontSet.load(face)
        if (!loaded.length || loaded.some((font) => font.status !== 'loaded'))
          throw new Error(FONT_LOAD_ERROR)
      })),
      new Promise((_, reject) => {
        timeout = setTimeout(() => reject(new Error(FONT_LOAD_ERROR)), FONT_LOAD_TIMEOUT_MS)
      }),
    ])
  } catch {
    throw new Error(FONT_LOAD_ERROR)
  } finally {
    clearTimeout(timeout)
  }
}
